var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ResponsiveCarousel, CarouselItem } from '@lux-sandbox/carousel';
import { CarouselWithTitle, ErrorBoundary } from '..';
import { ResponsiveCarouselWrapper } from './article-carousel.styles';
var noop = function () { };
export var ArticleCarousel = function (_a) {
    var id = _a.id, title = _a.title, children = _a.children, textTitle = _a.textTitle, _b = _a.onScroll, onScroll = _b === void 0 ? noop : _b, _c = _a.onSettled, onSettled = _c === void 0 ? noop : _c, _d = _a.isOverflowCarousel, isOverflowCarousel = _d === void 0 ? false : _d, background = _a.background, beforeTitle = _a.beforeTitle, afterTitle = _a.afterTitle, dataTestId = _a.dataTestId;
    return (React.createElement(ErrorBoundary, { componentName: id },
        React.createElement(CarouselWithTitle, __assign({ id: id, title: title, textTitle: textTitle, isOverflowCarousel: isOverflowCarousel }, (background ? { background: background } : {}), { beforeTitle: beforeTitle, afterTitle: afterTitle, dataTestId: dataTestId }),
            React.createElement(ResponsiveCarouselWrapper, { "$isOverflowCarousel": isOverflowCarousel },
                React.createElement(ResponsiveCarousel, { visibleItems: 2.2, visibleItemsXs: 3.2, visibleItemsSm: 3.2, visibleItemsMd: 5.2, visibleItemsLg: 6.2, "aria-labelledby": id, 
                    // TODO: A11Y - Provide localised keys.
                    previousSlideLabel: "", 
                    // TODO: A11Y - Provide localised keys.
                    nextSlideLabel: "", withOverflow: true, onScroll: onScroll, onSettled: onSettled }, React.Children.map(children, function (child, i) { return (
                // eslint-disable-next-line react/no-array-index-key -- items are dynamically generated and don't have stable IDs
                React.createElement(CarouselItem, { key: i }, child)); }))))));
};
